import { Component, Input, OnInit } from '@angular/core';
import { getAge } from '@src/app/shared/utils/common.util';
import { WatchlistTGAlert } from '../../meme-dashboard.type';
import { getHandledMemeRunTimer } from '../../meme-dashboard.util';

@Component({
    selector: 'app-recent-tg-alert-item',
    templateUrl: './recent-tg-alert-item.component.html',
    styleUrls: ['./recent-tg-alert-item.component.less'],
})
export class RecentTgAlertItemComponent implements OnInit {
    @Input() alertItem: WatchlistTGAlert;

    buyTimer: string;

    lastBuyTimeAge: string;

    ngOnInit() {
        this.buyTimer = getHandledMemeRunTimer(this.alertItem.meme_run_timer);
        this.lastBuyTimeAge = getAge(this.alertItem.smart_money_last_trade_block_timestamp, { isShort: true });
    }
    openTokenDetail() {
        window.open(`/meme-dashboard/token/${this.alertItem.chain_name}/${this.alertItem.token_address}`, '_blank');
    }
}
